import styles from "../../assets/scss/modules/PublicListingSingle.module.scss";
import React, {useState} from 'react';
import {Tab, Tabs} from "@mui/material";
import ListingTabLot from "./Listing.Tab.Lot.tsx";
import ListingTabBuilding from "./Listing.Tab.Building.tsx";
import ListingTabRooms from "./Listing.Tab.Rooms.tsx";
import ListingTabCharacteristics from "./Listing.Tab.Characteristics.tsx";
import ListingTabInclExcl from "./Listing.Tab.InclExcl.tsx";
import ListingTabEvalSpend from "./Listing.Tab.EvalSpend.tsx";
import clsx from "clsx";
import useReactTexts from "../../hooks/useReactTexts.ts";

const cssroot = "xldt";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

const CustomTabPanel = (props: TabPanelProps) => {
    const {children, value, index, ...other} = props;

    return <div
        className={clsx(`${cssroot}__tab-panel p-7 rounded-none`, styles.tab__panel)}
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        {...other}
    >
        {/* Performance: only load contents when tab is activated (not good for SEO) */}
        {/*{value === index && children}*/}
        {/* SEO: always load tab contents all the time even if not visible */}
        {children}
    </div>
}

/**
 * Single Listing - Tabs to group attributes in sections
 * @constructor
 */
const ListingDetailTabs = () => {
    const {__} = useReactTexts();
    const [value, setValue] = useState(0);
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    }

    return (
        <div className={`${cssroot}__root mt-8 w-full`}>
            <h3>{__("Détails")}</h3>

            <div className={`${cssroot}__tabs mb-1`}>
                <Tabs
                    className={"mt-4"}
                    classes={{
                        flexContainer: clsx("flex-wrap", styles.tabs__wrapper),
                        indicator: "hidden",
                    }}
                    value={value}
                    onChange={handleChange}
                    variant="standard"
                    // note: in mobile, use 'vertical'
                    orientation="horizontal"
                >
                    <Tab label={__("Caractéristiques")}/>
                    <Tab label={__("Terrain")}/>
                    <Tab label={__("Bâtiment")}/>
                    <Tab label={__("Pièces")}/>
                    <Tab label={__("Inclusions & Exclusions")}/>
                    <Tab label={__("Évaluations & Dépenses")}/>
                </Tabs>
            </div>
            {/*<Divider className={""} />*/}

            {/* caractéristiques */}
            <CustomTabPanel value={value} index={0}>
                <ListingTabCharacteristics/>
            </CustomTabPanel>

            {/* terrain */}
            <CustomTabPanel value={value} index={1}>
                <ListingTabLot/>
            </CustomTabPanel>

            {/* bâtiment */}
            <CustomTabPanel value={value} index={2}>
                <ListingTabBuilding/>
            </CustomTabPanel>

            {/* pièces / unités */}
            <CustomTabPanel value={value} index={3}>
                <ListingTabRooms/>
            </CustomTabPanel>

            {/* inclusions & exclusions */}
            <CustomTabPanel value={value} index={4}>
                <ListingTabInclExcl/>
            </CustomTabPanel>

            {/* évaluations & dépenses */}
            <CustomTabPanel value={value} index={5}>
                <ListingTabEvalSpend/>
            </CustomTabPanel>

            {/* équipements (todo irrelevant, so remove) */}
            {/*<CustomTabPanel value={value} index={4}>*/}
            {/*    <ListingTabEquipment/>*/}
            {/*</CustomTabPanel>*/}
        </div>
    )
}

export default ListingDetailTabs;
